exports.sectionTileTemplate = {
    $type: "SectionTile",
    style: {
        title: {
            show: true,
        },
    },
};
